import { inject, injectWithTransform, singleton } from "tsyringe";
import { ConsentResolvedCallback } from "../types";
import {
  ConsentProviderInterface,
  ConsentStubProviderInterface,
} from "../consentProviders/consent-provider-interface";
import { OneTrust } from "../consentProviders/one-trust";
import { Logger, LoggerTransformer } from "@identity/utils";

@singleton()
export class OneTrustConsentStrategy
  implements ConsentProviderInterface, ConsentStubProviderInterface
{
  constructor(
    @injectWithTransform(Logger, LoggerTransformer, "OptInService")
    private logger: Logger,
    @inject(OneTrust) private oneTrust: OneTrust,
  ) {}

  subscribe(callback: ConsentResolvedCallback): void {
    this.logger.info("OneTrust installed");
    this.oneTrust.subscribe(callback);
  }

  getConsentApi(): "tcf" | "usp" | undefined {
    return this.oneTrust.getConsentApi();
  }

  getConsentString(): string | undefined {
    return this.oneTrust.getConsentString();
  }

  getConsents(optOut: boolean): Required<Categories> | undefined {
    return this.oneTrust.getConsents(optOut);
  }
}
